import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { authAPI, describirError } from '../services/api';
import PageHeader from '../components/PageHeader';
import '../styles/Perfil.css';

export default function Perfil() {
  const { user } = useAuth();

  const [passwordActual, setPasswordActual] = useState('');
  const [passwordNueva, setPasswordNueva] = useState('');
  const [passwordConfirm, setPasswordConfirm] = useState('');

  const [submitting, setSubmitting] = useState(false);
  const [feedback, setFeedback] = useState(null);

  const handleChangePassword = async (e) => {
    e.preventDefault();
    if (!passwordActual || !passwordNueva || !passwordConfirm) {
      setFeedback({ tipo: 'error', mensaje: 'Por favor complete todos los campos de contraseña.' });
      return;
    }

    if (passwordNueva.length < 8) {
      setFeedback({ tipo: 'error', mensaje: 'La nueva contraseña debe tener al menos 8 caracteres.' });
      return;
    }

    if (passwordNueva !== passwordConfirm) {
      setFeedback({ tipo: 'error', mensaje: 'La confirmación de la contraseña no coincide.' });
      return;
    }

    try {
      setSubmitting(true);
      setFeedback(null);
      await authAPI.changePassword({ passwordActual, passwordNueva });
      setFeedback({ tipo: 'exito', mensaje: '¡Contraseña actualizada correctamente!' });
      setPasswordActual('');
      setPasswordNueva('');
      setPasswordConfirm('');
    } catch (err) {
      const parsed = describirError(err);
      setFeedback({ tipo: 'error', mensaje: parsed.mensaje || 'Error al cambiar la contraseña.' });
    } finally {
      setSubmitting(false);
    }
  };

  const nombreCompleto = `${user?.nombre || ''} ${user?.apellidoPaterno || ''} ${user?.apellidoMaterno || ''}`.trim();

  return (
    <div className="perfil-container">
      <PageHeader
        title="Mi Perfil de Usuario"
        subtitle="Información de la cuenta y configuración de seguridad"
      />

      {feedback && (
        <div style={{
          padding: '12px 18px',
          marginBottom: '20px',
          borderRadius: '8px',
          backgroundColor: feedback.tipo === 'exito' ? '#ecfdf5' : '#fef2f2',
          color: feedback.tipo === 'exito' ? '#065f46' : '#991b1b',
          border: `1px solid ${feedback.tipo === 'exito' ? '#a7f3d0' : '#fecaca'}`
        }}>
          {feedback.mensaje}
        </div>
      )}

      <div className="perfil-grid">
        {/* Tarjeta de Información de Cuenta */}
        <div className="perfil-card">
          <h3 className="perfil-card-title">Datos del Usuario</h3>
          <div className="perfil-info-list">
            <div className="perfil-info-item">
              <span className="perfil-info-label">Nombre Completo</span>
              <span className="perfil-info-val">{nombreCompleto || '—'}</span>
            </div>
            <div className="perfil-info-item">
              <span className="perfil-info-label">Correo Electrónico</span>
              <span className="perfil-info-val">{user?.email}</span>
            </div>
            <div className="perfil-info-item">
              <span className="perfil-info-label">Nombre de Usuario</span>
              <span className="perfil-info-val">{user?.username ? `@${user.username}` : 'No definido'}</span>
            </div>
            <div className="perfil-info-item">
              <span className="perfil-info-label">Rol Asignado</span>
              <span className="perfil-info-val" style={{ color: '#2563eb' }}>
                {user?.rol?.nombre || user?.rol?.codigo}
              </span>
            </div>
            <div className="perfil-info-item">
              <span className="perfil-info-label">Estado de la Cuenta</span>
              <span className="perfil-info-val" style={{ color: user?.activo ? '#059669' : '#dc2626' }}>
                {user?.activo ? 'Activo' : 'Inactivo'}
              </span>
            </div>
            <div className="perfil-info-item">
              <span className="perfil-info-label">Último Acceso</span>
              <span className="perfil-info-val" style={{ color: '#64748b' }}>
                {user?.ultimoAccesoEn
                  ? new Date(user.ultimoAccesoEn).toLocaleString('es-MX', {
                      dateStyle: 'medium',
                      timeStyle: 'short'
                    })
                  : 'Sesión actual'}
              </span>
            </div>
          </div>

          <div style={{ marginTop: '20px' }}>
            <span className="perfil-info-label">Permisos Habilitados ({user?.permisos?.length || 0})</span>
            <div className="perfil-permisos-tags">
              {(user?.permisos || []).map((permiso) => (
                <span key={permiso} className="perfil-permiso-tag">
                  {permiso}
                </span>
              ))}
            </div>
          </div>
        </div>

        {/* Tarjeta de Cambio de Contraseña */}
        <div className="perfil-card">
          <h3 className="perfil-card-title">Cambiar Contraseña</h3>
          <form onSubmit={handleChangePassword} style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
            <div className="login-field-group">
              <label className="login-label">Contraseña Actual *</label>
              <input
                type="password"
                className="usuarios-search-input"
                placeholder="••••••••"
                value={passwordActual}
                onChange={(e) => setPasswordActual(e.target.value)}
                required
                disabled={submitting}
              />
            </div>

            <div className="login-field-group">
              <label className="login-label">Nueva Contraseña * (mínimo 8 caracteres)</label>
              <input
                type="password"
                className="usuarios-search-input"
                placeholder="••••••••"
                value={passwordNueva}
                onChange={(e) => setPasswordNueva(e.target.value)}
                required
                minLength={8}
                disabled={submitting}
              />
            </div>

            <div className="login-field-group">
              <label className="login-label">Confirmar Nueva Contraseña *</label>
              <input
                type="password"
                className="usuarios-search-input"
                placeholder="••••••••"
                value={passwordConfirm}
                onChange={(e) => setPasswordConfirm(e.target.value)}
                required
                minLength={8}
                disabled={submitting}
              />
            </div>

            <button
              id="btn-cambiar-password"
              type="submit"
              className="btn btn-primary"
              style={{ marginTop: '8px', alignSelf: 'flex-start' }}
              disabled={submitting}
            >
              {submitting ? 'Actualizando...' : 'Actualizar Contraseña'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}
